import RoomService from "../services/room.service"

const roomQueryParam = "roomName";

let hash = location.pathname;

let roomName = new URL(location).searchParams.get(roomQueryParam);

// TODO remove hard coded value
hash = "bafybeiemxf5abjwjbikoz4mc3a3dla6ual3jsgpdr4cjr3oz3evfyavhwq"
roomName = "butthole"

export default new RoomService(hash, roomName);